import {FormattedMessage, injectIntl} from "react-intl";
import CSSModules from "react-css-modules";
import styles from "../auth.scss";
import React from "react";
import PropTypes from "prop-types";
import {Timer} from "../../components/timer/timer";

@injectIntl
@CSSModules(styles, {allowMultiple: true})
export class TooManyAttempts extends React.Component {

  static propTypes = {
    timeLeft: PropTypes.number,
    onTimerEnd: PropTypes.func,
  };

  render() {
    return (
      <div styleName="otpTooManyAttemptsContainer">
        <div styleName="title">
          <FormattedMessage id={'registration/forgotPassword.TooManyAttempts.exceeded'}/>
        </div>
        <div styleName="tryAgain">
          <FormattedMessage id={'registration/forgotPassword.TooManyAttempts.tryAgain'}/>
        </div>
        {
          this.props.timeLeft && 
          <div styleName="retryIn">
            <FormattedMessage id={'registration/forgotPassword.TooManyAttempts.retryIn'}/>{' '}
            <Timer time={this.props.timeLeft} onTimerEnd={() => {this.props.onTimerEnd();}}/>
          </div>
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/auth/authWithOtp/TooManyAttempts.js